import BaseService from './base.service';

export default class NotificationsService extends BaseService {
  getUnreadNotifications(criteria) {
    const queryString = this.getQueryString(criteria);
    return this.get(`/notification/unread${queryString}`);
  }

  readNotification(id) {
    return this.post(`/notification/${id}/read`);
  }

  readAllNotification() {
    return this.post('/notification/read');
  }
}
